module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/hiking.svg?91165b6b397c127e262315af33cf31d6";